/* eslint-disable max-len */
import React from 'react';
function ProfessionalDevelopment() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M13 5C14.1 5 15 4.1 15 3C15 1.9 14.1 1 13 1C11.9 1 11 1.9 11 3C11 4.1 11.9 5 13 5ZM8.8 8.39999L6 21.25H8.1L9.9 14.5L12 16.5V19.75H14V15L11.9 13L12.5 10C13.8 11.5 15.8 12.5 18 12.5V10.5C16.1 10.5 14.5 9.5 13.7 8.1L12.7 6.5C12.14 5.60999 11.02 5.25 10.05 5.66L5 7.8V12.5H7V9.09999L8.8 8.39999ZM9 22.75H6V23.75H9V22.75ZM14 20.75V23.75H11V20.75H14ZM19 16.75H16V23.75H19V16.75Z" })));
}
export default ProfessionalDevelopment;
